module.exports = __webpack_public_path__ + "img/EnergyViewV2.d43ceeff.png";